import APIV5 from '~/models/api';
import WorkflowAffect from '~/scripts/services/model/workflow-affect';

export default class WfAffectHistoryController {
	/* @ngInject */
	/**
	 * @param {import('angular').auto.IInjectorService} $injector
	 * @param {import('angular').ITimeoutService} $timeout
	 */
	constructor($injector, $timeout) {
		this.$injector = $injector;
		this.$timeout = $timeout;

		/** @type {?import('@knitiv/api-client-javascript').KNode} */
		this.affectKid = null;

		/** @type {boolean} */
		this.displayHistory = false;
	}

	async loadAffectHisto(){
		if (this.affectKid) {
			const affectHisto = await APIV5.instance.wfAffectHisto({
				wfaffect_kid: this.affectKid,
			}, {
				id: 'wf-form-actions.init-workflow',
			});
			this.$timeout(() => {
				this.histo = affectHisto.histo.map(histo => new WorkflowAffect(this.$injector, histo));
			});
		}
	}

	$onInit() {
		(async() => this.loadAffectHisto())();
	}
}
